module.exports = __webpack_public_path__ + "img/bell.6f988e8c.svg";